import { useState } from "react";
import Modal from "../../../components/ui/Modal";
import { ApiService } from "../../../services/api";
import type { PracticeExam } from "../../../types/practice-exam";
import ExamAudiencePicker, { ExamTargetDepartment } from "./ExamAudiencePicker";

// Deneme ayarları: ad ve tarih (2 Kas), kimlere açık olduğu (26 Eki). Önceden çözmeye başlamış öğrenci kendi kaydını sürdürebilir.
// Yayınevi denemesinde alan puanı (SAY/EA/SÖZ + alan sırası) da buradan açılıp kapanır; açılınca var olan sonuçlar puanlanır.
export default function ExamAudienceModal({
  exam,
  onClose,
  onSaved,
}: {
  exam: PracticeExam;
  onClose: () => void;
  onSaved: () => void;
}) {
  const [name, setName] = useState(exam.name || "");
  const [date, setDate] = useState((exam.date || "").slice(0, 10));
  const [departments, setDepartments] = useState<ExamTargetDepartment[]>(exam.targetDepartments || []);
  const isPublisher = !(exam.systemType === "internal" || exam.isInternal);
  const [alanPuani, setAlanPuani] = useState(Boolean(exam.alanPuani));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const save = async () => {
    if (name.trim().length < 2) {
      setError("Deneme adı en az 2 karakter olmalı");
      return;
    }
    setSaving(true);
    setError(null);
    try {
      const extra: { name?: string; date?: string } = {};
      if (name.trim() !== exam.name) extra.name = name.trim();
      if (date && date !== (exam.date || "").slice(0, 10)) extra.date = date;
      await ApiService.updatePracticeExamAudience(exam.id, departments.map((d) => d.id), isPublisher ? alanPuani : undefined, extra);
      onSaved();
    } catch (e: any) {
      setError(e?.message || "Kaydedilemedi");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal isOpen onClose={onClose} title="Deneme ayarları" size="md" overflowVisible>
      <div className="space-y-4">
        <div className="grid gap-3 sm:grid-cols-[1fr_10rem]">
          <label className="block text-sm font-medium text-gray-700">
            Deneme adı
            <input value={name} onChange={(e) => setName(e.target.value)} maxLength={200} disabled={saving} className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm" />
          </label>
          <label className="block text-sm font-medium text-gray-700">
            Tarih
            <input type="date" value={date} onChange={(e) => setDate(e.target.value)} disabled={saving} className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm" />
          </label>
        </div>
        <p className="border-t border-gray-100 pt-3 text-sm font-medium text-gray-700">Kimler görsün</p>
        <ExamAudiencePicker value={departments} onChange={setDepartments} disabled={saving} />
        {isPublisher && (
          <label className="flex items-start gap-2 border-t border-gray-100 pt-3 text-sm text-gray-700">
            <input
              type="checkbox"
              checked={alanPuani}
              onChange={(e) => setAlanPuani(e.target.checked)}
              disabled={saving}
              className="mt-0.5 h-4 w-4 rounded border-gray-300 text-blue-600"
            />
            <span>
              <span className="font-medium">SAY / EA / SÖZ alan puanı ve alan sırası</span>
              <span className="block text-xs text-gray-500">Her test 40 soruya tamamlanır, alan 80 soru × 5 = 400 + 100 taban (en çok 500).</span>
            </span>
          </label>
        )}
        {error && <p className="text-sm text-red-600">{error}</p>}
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} disabled={saving} className="rounded-md border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">
            Vazgeç
          </button>
          <button type="button" onClick={save} disabled={saving} className="rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-60">
            {saving ? "Kaydediliyor…" : "Kaydet"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
